import { BrowserRouter } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import './ui/_module/i18n';
import { CookiesProvider } from 'react-cookie';

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SnackbarProvider } from 'notistack';
import { makeStyles } from '@mui/styles';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import ThemeProvider from './ui/_module/ThemeProvider';
import ApolloProvider from './ui/_module/ApolloProvider';
import ErrorBoundary from './ui/_module/ErrorBoundary';
import ContextWrapper from './ui/_module/ContextWrapper';
import Helmet from './ui/components/Helmet';
import Switch from './ui/_module/Switch';
import useEnvironment from './ui/components/_hook/useEnvironment';

const useStyles = makeStyles((theme) => ({
  bgSuccess: {
    backgroundColor: '#80C53A !important',
  },
  bgError: {
    backgroundColor: '#F92949 !important',
  },
  bgWarning: {
    backgroundColor: '#FE801E !important',
  },
  bgInfo: {
    backgroundColor: '#FFFF28 !important',
  },
}));

function App() {
  const { t } = useTranslation();
  const env = useEnvironment();
  const classes = useStyles();

  const MemoSwitch = useMemo(() => <Switch />, []);

  return (
    <>
      <Helmet title={`${t('keepital')}`} />
      <CssBaseline />
      <CookiesProvider>
        <ThemeProvider>
          <SnackbarProvider
            classes={{
              variantSuccess: classes.bgSuccess,
              variantError: classes.bgError,
              variantWarning: classes.bgWarning,
              variantInfo: classes.bgInfo,
            }}
            maxSnack={3}
            anchorOrigin={{
              horizontal: 'left',
              vertical: 'bottom',
            }}
          >
            <ApolloProvider>
              <ContextWrapper>
                <BrowserRouter>
                  <PayPalScriptProvider
                    options={{
                      'client-id': env.REACT_APP_PAYPAL_CLIENT_ID,
                      vault: true,
                      intent: 'subscription',
                      debug: false,
                      components: 'buttons',
                    }}
                  >
                    <ErrorBoundary>{MemoSwitch}</ErrorBoundary>
                  </PayPalScriptProvider>
                </BrowserRouter>
              </ContextWrapper>
            </ApolloProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </CookiesProvider>
    </>
  );
}

export default App;
